import axios from 'axios'
import {API_URL} from '../../config/env'
import {AuthModel} from '../../models/AuthModel'
import { SiteSettingModel } from '../../models/SiteSettingModel'

export const login = (username: string, password: string) =>
  axios.post<AuthModel>(`/auth/login`, {username, password})

export const validateMfa = (mfa: string, token: string) =>
  axios.create({baseURL: API_URL}).post<AuthModel>(
    `/auth/validate-mfa`,
    {mfa},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )

export const validateToken = () => axios.get<AuthModel>('/auth/verify-token')

export const forgotPassword = (email: string) => axios.post(`/auth/forgot-password`, {email})

export const validateHash = (username: string, password: string, hash: string) =>
  axios.post(`/auth/login-hash`, {username, password, hash})

export const resetPassword = (password: string) => axios.post(`/auth/reset`, {password})

export const getSiteSettings = () => axios.get<SiteSettingModel>(`/setting`)
export const updateSiteSettings = (data: SiteSettingModel) => axios.post(`/setting`, data)
